export const DELIVERY = 'DELIVERY';
export const STORAGE = 'STORAGE';
export const EXPORTCONSOL = 'EXPORTCONSOL';